import * as React from 'react';

import { useSkinAnalyzerBrandData } from '../hooks/useSkinAnalyzerBrandData';
import { Image } from '../styled';

export const BrandImage = () => {
  const brand = useSkinAnalyzerBrandData();

  return <Image src={brand?.banner} alt="skin analyser image" />;
};
